<template>
  <div class="body">
        <p  class="font1" style="padding-top: 8vh;">默默耕耘，铸就辉煌</p>
        <p class="title" style="padding-top: 5vh;width: 90%;">2025年九月你的个人发展与成长：</p>
        <div v-html="activity" v-for="(activity, idx) in activityList" :key="idx" style="width: 90%;margin: 0 auto;" class="title"></div>
        <!-- <p class="font2" v-if="course!==''"> <i class="fa fa-check"></i>完成了<a class="font3">{{ this.course }}</a>培训</p> -->
        <!-- <p class="font2" v-if="promote!==''"> <i class="fa fa-check"></i>顺利晋升为<a class="font3">{{ this.promote }}</a></p>
        <p class="font2" v-if="teacher!==''"> <i class="fa fa-check"></i>通过讲师认证，成为<a class="font3">{{ this.teacher }}</a></p>          -->
        <p class="font2" style="padding-top: 4vh;margin: 0;">每一次培训与认证</p>
        <p class="font2" style="margin: 0;">都是你专业成长的阶梯</p>
        <p class="font2" style="margin: 0;">每一份坚持</p>
        <p class="font2" style="margin: 0;">都是通往未来成功的基石</p>
        <p class="font2" style="margin: 0;">继续学习，你的前途将更加光明～</p>  
  </div>
</template>

<script>
export default {
    props:['ReportData'],
    data(){
        return {
            certificateList:[]
        }
    },
    created() {
        this.parseActivity();
    },
    methods: {
        parseActivity() {
            try {
                const obj =JSON.parse(this.ReportData.activity || '[]')
                // 生成一个前端可直接用的数组
                this.activityList = obj.map(item => {
                    if (item.name === '讲师评审' || item.name === '2025年集团优秀讲师评选') {
                        return `<p class=" title">
                                <i class="fa fa-check"></i>
                                参加了<a style="color: #fff;">${item.name}</a>，获得了<a style="color: #fff;">${item.certificate}</a>证书
                                </p>`
                    } else if (item.name === '鸿鹄系列训练营') {
                        return `<p class=" title">
                                <i class="fa fa-check"></i>
                                完成了<a style="color: #fff;">${item.certificate}</a>培训
                                </p>`
                    } else if(item.name === 'TTT企业内部讲师培训') {
                        // 默认展示
                        return `<p class=" title">
                                <i class="fa fa-check"></i>
                                参加了<a style="color: #fff;">企业内部讲师培训${item.certificate}</a>
                                </p>`
                    }
                })
            } catch (e) {
                console.error("activity 解析失败", e);
                this.activityList = []
            }
        }

    }
}
</script>

<style scoped>
.body {
    background: 
        url("../../assets/25September/logo.png") right  top  no-repeat,
        url("../../assets/25September/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}
.font1 {
    width: 96%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #0D1B2A;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.title{
    text-align: left;
    width: 96%;
    margin: 0 auto;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
@media screen and (min-width: 786px) {
    .body {
        background: 
                    url("../../assets/25September/pcbg.jpg")  no-repeat;
        background-size:cover;
        width: 100%;
        height: 100vh;
    }
    .font1{
        text-align: center;
    }
    .font2{
        font-size: 19px;
    }
    .title{
        text-align: center;
    }
}
</style>